import './styles.css';
import { renderShell, setFooter, setStamp, setSubtitle } from './components/Shell';
import { loadAll } from './data/loaders';
import type { AppData } from './data/types';
import { renderPortfolio } from './views/portfolio';
import { renderInventario } from './views/inventario';
import { renderArbol } from './views/arbol';
import { renderHuecos } from './views/huecos';
import { renderVision } from './views/vision';
import type { ViewId } from './router';

let data: AppData | null = null;

async function bootstrap() {
  const app = document.getElementById('app')!;
  app.innerHTML = '<div class="m-auto text-slate-500 text-sm">Cargando datos del repositorio…</div>';
  try {
    data = await loadAll();
  } catch (e) {
    app.innerHTML = `<div class="m-auto max-w-md p-6 text-sm">
      <div class="rounded-lg border border-rose-200 bg-rose-50 p-4 text-rose-700">
        <div class="font-semibold mb-2">No se pudieron cargar los datos</div>
        <pre class="text-xs whitespace-pre-wrap">${String(e)}</pre>
        <div class="mt-3 text-xs text-rose-600">Verifica que ejecutaste <code>npm run sync-data</code> antes de levantar el dev server.</div>
      </div>
    </div>`;
    return;
  }
  renderShell(app, (view, container) => renderView(view, container));
  setFooter(`${data.skus.length} SKUs · ${data.metrics.length} métricas`);
  setStamp(`Cargado ${data.loadedAt.toLocaleTimeString('es-CO')}`);
}

function renderView(view: ViewId, container: HTMLElement): void {
  if (!data) return;
  setSubtitle('');
  switch (view) {
    case 'vision':
      setSubtitle('Narrativa en 5 secciones — para mostrar a stakeholders');
      renderVision(container, data);
      break;
    case 'portfolio':
      setSubtitle('Catálogo de SKUs comercializables');
      renderPortfolio(container, data);
      break;
    case 'inventario':
      setSubtitle('Inventario completo de métricas e indicadores');
      renderInventario(container, data);
      break;
    case 'arbol':
      setSubtitle('Plataforma → Suite → Producto → Módulo → Tipo → KPI');
      renderArbol(container, data);
      break;
    case 'huecos':
      setSubtitle('Estado de decisiones y contradicciones documentadas');
      renderHuecos(container, data);
      break;
  }
}

bootstrap();
